import { render, staticRenderFns } from "./QuestionAlert.vue?vue&type=template&id=4f350d79&scoped=true&"
import script from "./QuestionAlert.vue?vue&type=script&lang=js&"
export * from "./QuestionAlert.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAlert.vue?vue&type=style&index=0&id=4f350d79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f350d79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
